import { render, staticRenderFns } from "./sa-login.vue?vue&type=template&id=2e965c8b&scoped=true&"
import script from "./sa-login.vue?vue&type=script&lang=js&"
export * from "./sa-login.vue?vue&type=script&lang=js&"
import style0 from "./sa-login.vue?vue&type=style&index=0&id=2e965c8b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e965c8b",
  null
  
)

export default component.exports